import type { QueryFunctionContext } from '@tanstack/react-query';
import { TeamsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import type { teamsKeys } from './teamsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof teamsKeys.renameSlugAvailability>>;

export const createFetchTeamRenameSlugAvailabilityQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, organizationRoleId, slug }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(TeamsService.isTeamSlugAvailable({ oid: organizationId, organizationRoleId, slug }), signal),
    );
